import _defineProperty from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import db from "@/components/firebaseInit";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment";
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required;

export default {
  components: {
    "quill-editor": quillEditor
  },
  data: function data() {
    var _ref;

    return _ref = {
      content: "",
      editorOption: {// some quill options
      },
      id: "",
      title: ""
    }, _defineProperty(_ref, "content", ""), _defineProperty(_ref, "date", moment().format("DD/MM/YYYY hh:mm a")), _ref;
  },
  mixins: [validationMixin],
  validations: {
    title: {
      required: required
    },
    content: {
      required: required
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    db.collection("biography").doc(to.params.id).get().then(function (querySnapshop) {
      if (!querySnapshop.exists) {
        console.log("No such document!");
      } else {
        console.log("Document data:", querySnapshop.data());
        next(function (vm) {
          vm.id = to.params.id;
          vm.title = querySnapshop.data().title;
          vm.content = querySnapshop.data().content;
        });
      }
    });
  },
  methods: {
    onValitadeFormSubmit: function onValitadeFormSubmit() {
      console.log("submit!");
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.$notify("error", "Add Bio error", "", {
          duration: 3000,
          permanent: false
        });
      } else {
        // do your submit logic here
        this.updateBio();
      }

      console.log(JSON.stringify({
        title: this.title,
        content: this.content
      }));
    },
    updateBio: function updateBio() {
      var _this = this;

      console.log(this);
      console.log("this id update bio " + this.id);
      console.log("this data update bio " + this.data);
      db.collection("biography").doc(this.id).set({
        title: this.title,
        date: this.date,
        content: this.content
      }).then(function () {
        _this.$notify("success", "updated Bio success", "", {
          duration: 3000,
          permanent: false
        });

        _this.$router.push("/app/dashboards/biography/bio-list");
      }).catch(function (error) {
        console.error("Error updated bio: ", error);
      });
    },
    onEditorChange: function onEditorChange(_ref2) {
      var quill = _ref2.quill,
          html = _ref2.html,
          text = _ref2.text;
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
    fetchData: function fetchData() {
      var _this2 = this;

      db.collection("biography") // .where("id", "==", this.$route.params.id)
      .doc(to.params.id).get().then(function (querySnapshop) {
        if (!querySnapshop.exists) {
          console.log("No such document!");
        } else {
          console.log("Document data:", querySnapshop.data());
          _this2.id = querySnapshop.data().id;
          _this2.title = querySnapshop.data().title;
          _this2.content = querySnapshop.data().content;
        }
      });
    }
  },
  watch: {
    $route: "fetchData"
  }
};